import { z } from 'zod';
import { baseCertificateSchema } from './IBaseCertificate';

// Schemas (source of truth)
export const projectCertificateSchema = baseCertificateSchema.extend({
	_id: z.string(),
	projectId: z.string(),
});

// Types (derived from schemas)
export type IProjectCertificate = z.infer<typeof projectCertificateSchema>;
